.section {
	@apply yst-py-8 yst-space-y-4;
}

.toolbar {
	@apply yst-flex yst-flex-wrap yst-items-end yst-justify-between yst-gap-4;
}

// Cancels the Search component's own bottom margin so the button aligns with the input.
.toolbarSearch {
	@apply yst--mb-6 yst-w-full sm:yst-w-96;

	input {
		@apply yst-w-full;
	}
}

.actionIcon {
	@apply yst-w-4 yst-h-4;
}

.empty {
	@apply yst-text-slate-600;
}

.tableContainer {
	// The ui-library only sets `min-width: 100%` on the table, so with
	// `table-layout: auto` a narrow content set leaves the table narrower than
	// its wrapper. Force full width so borders span edge to edge.
	table {
		@apply yst-w-full;
	}

	@media (max-width: 1279.98px) {
		max-width: 32rem;
	}
}

// Same stacked-card collapse as the personal access tokens page: eight no-wrap
// columns do not fit next to the sidebar below `xl`.
.tableHead {
	@apply yst-hidden xl:yst-table-header-group;
}

.tableBody {
	td::before {
		content: attr(data-label);
		@apply yst-font-bold yst-text-slate-500 xl:yst-hidden;
	}

	td:last-of-type::before {
		@apply yst-hidden;
	}

	@media (max-width: 1279.98px) {
		display: block !important;

		tr {
			@apply yst-py-4;

			display: block !important;
		}

		td {
			@apply yst-items-start yst-gap-0.5 yst-px-0 yst-py-1.5;

			display: flex !important;
			flex-direction: column;
		}
	}
}

.actionsCell {
	@apply yst-relative;
}

.dropdownList {
	@apply yst-absolute yst-right-0 yst-z-10 yst-mt-2 yst-w-auto yst-min-w-max;

	// The items are ui-library Buttons, which center their label; a menu reads left-aligned.
	button {
		@apply yst-w-full yst-text-left;

		justify-content: flex-start !important;
	}
}

.dangerItem {
	@apply yst-text-red-600;
}

.modalBody {
	@apply yst-flex yst-flex-col yst-gap-4 yst-my-4;
}

.modalActions {
	@apply yst-flex yst-justify-end yst-gap-3;
}

.irreversible {
	@apply yst-font-bold yst-mt-2;
}

.detailCard {
	@apply yst-max-w-3xl;
}

.detailList {
	@apply yst-grid yst-gap-x-8 yst-gap-y-3 yst-m-0;

	grid-template-columns: max-content 1fr;

	dt {
		@apply yst-font-bold yst-text-slate-500;
	}

	dd {
		@apply yst-m-0;
	}
}

.downloadLinks {
	@apply yst-flex yst-flex-col yst-gap-1;
}

.detailValue {
	@apply yst-flex yst-flex-col yst-items-start yst-gap-1;
}

.detailActionRow {
	@apply yst-flex yst-flex-wrap yst-gap-x-4 yst-gap-y-1;
}

.productGroup {
	@apply yst-space-y-3;
}

.toastFlex {
	@apply yst-flex yst-gap-3 yst-relative;
}

.toastIcon {
	@apply yst-w-6 yst-h-6 yst-shrink-0;
}

.toastSuccess {
	@apply yst-text-green-500;
}

.toastError {
	@apply yst-text-red-500;
}

.toastClose {
	@apply yst-absolute yst-right-0 yst-top-0;
}
